<template>
    <a-modal
        :visible="visible"
        title="新增IP地址"
        @ok="on_submit"
        @cancel="cancel"
        :confirmLoading="submitting"
        :after-close="after_close"
        :width="480"
    >
        <a-form-model :model="form" :rules="rules" ref="ip-create">
            <a-form-model-item label="IP" prop="ip">
                <a-input v-model="form.ip"></a-input>
            </a-form-model-item>
            <a-form-model-item label="备注">
                <a-input type="textarea" v-model="form.remark"></a-input>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>
<script>
let init_form = { ip: null, remark: null };
export default {
    props: {
        visible: {
            default: false
        },
        record: null,
        mode: {
            default: "create"
        }
    },
    created() {
        this.form = init_form;
    },
    data() {
        return {
            submitting: false,
            form: null,
            rules: {
                ip: [
                    {
                        required: true,
                        trigger: ["change", "blur"],
                        message: "请输入IP地址"
                    }
                ]
            }
        };
    },
    watch: {
        visible(v) {
            if (v && this.record) {
                this.form = JSON.parse(JSON.stringify(this.record));
            }
        }
    },
    methods: {
        cancel() {
            this.$emit("close");
        },
        on_submit() {
            this.$refs["ip-create"].validate(valid => {
                if (valid) {
                    this.submitting = true;
                    this.$http
                        .post("/setting/ip_whitelist", this.form)
                        .then(res => {
                            if (res.success) {
                                this.cancel();
                                this.$emit("load");
                            } else {
                                this.$message.error(res.message);
                            }
                        })
                        .catch(() => {})
                        .then(() => {
                            this.submitting = false;
                        });
                } else {
                    this.$message.error("请检查并填写完需要录入的内容");
                    return false;
                }
            });
        },
        after_close() {
            this.$refs["ip-create"].resetFields();
            this.form = JSON.parse(JSON.stringify(init_form));
        }
    }
};
</script>

<style lang="less" scoped>
.img-uploader-avatar {
    /deep/.ant-upload {
        overflow: hidden;
        border-radius: 50%;
        .ant-upload {
            padding: 0 !important;
        }
    }
}
.img-uploader-banner {
    /deep/.ant-upload {
        overflow: hidden;
        width: 100%;
    }
}
</style>
